import React, {useEffect, useState} from 'react';
import Bus from './Bus';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    // @ts-ignore
    return <MuiAlert elevation={6} ref={ref}  {...props} />;
});

export const Flash = () => {
    let [visibility, setVisibility] = useState(false);
    let [message, setMessage] = useState('');
    let [type, setType] = useState('');

    const [open, setOpen] = React.useState(true);


    const handleClose = (_: any, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    useEffect(() => {
        Bus.addListener('flash', ({message, type}) => {
            setOpen(true);
            setVisibility(true);
            setMessage(message);
            setType(type);
            setTimeout(() => {
                setOpen(false);
                setVisibility(false);
            }, 3000);
        });
    }, []);

    useEffect(() => {
        if (document.querySelector('.close') !== null) {
            document.querySelector('.close')?.addEventListener('click', () => setVisibility(false));
        }
    })

    return (
        visibility ? <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            {/*@ts-ignore*/}
            <Alert onClose={handleClose} severity={type} sx={{width: '100%'}}>
                {message}
            </Alert>
        </Snackbar> : <></>
    )
}
export default Flash;
